<template>
    <div v-if="textsStore.haveAQuestion && !isCmsRoute" class="have-a-question-wrapper" :class="side"
        :style="{ bottom: bottomOffset + 'px' }">
        <!--<button class="close-btn" @click="close">×</button> -->
        <img :src="imageSrc" alt="Masz pytanie?" class="have-a-question" :class="side" @click="goToContact" />
    </div>
</template>

<script>
import router from '@/router'
import { useRoute } from 'vue-router'
import { useTextsStore } from '@/stores/textsStore'
import { computed, ref, onMounted, onBeforeUnmount } from 'vue'

export default {
    name: 'HaveAQuestion',
    props: {
        side: {
            type: String,
            default: 'right',
            validator: val => ['left', 'right'].includes(val),
        },
    },
    setup(props) {
        const textsStore = useTextsStore()
        const route = useRoute()
        const bottomOffset = ref(0)

        const isCmsRoute = computed(() => route.path.includes('/cms'))

        const imageSrc = computed(() =>
            props.side === 'left'
                ? require('@/assets/images/Masz_pytanie_prawy-1.png')
                : require('@/assets/images/Masz_pytanie_lewy.png')
        )

        const updatePosition = () => {
            const footer = document.querySelector('footer, .summary-footer')
            if (!footer) return

            const footerRect = footer.getBoundingClientRect()
            const windowHeight = window.innerHeight

            if (footerRect.top < windowHeight) {
                bottomOffset.value = windowHeight - footerRect.top
            } else {
                bottomOffset.value = 0
            }
        }

        onMounted(() => {
            window.addEventListener('scroll', updatePosition)
            window.addEventListener('resize', updatePosition)
            updatePosition()
        })

        onBeforeUnmount(() => {
            window.removeEventListener('scroll', updatePosition)
            window.removeEventListener('resize', updatePosition)
        })

        const goToContact = () => {
            window.scrollTo(0, 0)
            router.push('/contact')
        }

        const close = () => {
            textsStore.haveAQuestion = false
        }

        return {
            textsStore,
            imageSrc,
            goToContact,
            close,
            bottomOffset,
            isCmsRoute,
        }
    },
}
</script>

<style scoped lang="scss">
.have-a-question-wrapper {
    position: fixed;
    margin: 0px 20px;
    z-index: 100;
    display: flex;
    align-items: flex-start;
    transition: bottom 0.3s ease;

    &.right {
        right: 20px;
    }

    &.left {
        left: 20px;
    }
}

.have-a-question {
    height: 180px;
    width: auto;
    cursor: pointer;
    opacity: 0;
    animation: slide-in 0.8s ease-out forwards;

    @media screen and (max-width: 768px) {
        height: 15vh;
    }
}

.close-btn {
    position: absolute;
    top: -20px;
    background: $color-primary;
    color: $color-white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    font-size: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 101;

    &:hover {
        background: $color-primary-lighter;
        color: $color-black;
    }

    .have-a-question-wrapper.left & {
        left: -10px;
    }

    .have-a-question-wrapper.right & {
        right: 0px;
    }

    @media (max-width: 768px) {
        top: -10px;
        width: 30px;
        height: 30px;
        font-size: 18px;
    }
}

@keyframes slide-in {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
